import { Injectable } from "@angular/core";
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from "@angular/router";
import { AuthService } from "./authentication.servicie";
import { routePaths, mainMenus } from "../config";
import { PaginationService } from "../../services/pagination.service"

@Injectable()
export class AuthGuard implements CanActivate {
  sub : any;
  constructor(private authService: AuthService, private router: Router, private paginationService: PaginationService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;

    this.dateFilter(url);
    return this.checkLogin(url);
  }
  dateFilter(url) {
    if (url.indexOf('waybillsignoff') != -1) {
      this.authService.saveValue('signoffdateObj', null);
    } else if (url.indexOf('waybillReport') != -1) {
      this.authService.saveValue('summarydateObj', null);
    } else if (url.indexOf('prepaid-cards') != -1) {
      this.authService.saveValue('PrePaidCarddateObj', null);

    } else if (url.indexOf('spotTicket') != -1) {
    this.authService.saveValue('spotTicketReporteObj', null);
    }
    else if(url.indexOf('assignETIM') != -1){
      this.authService.saveValue("assignETIMdateObj", null);
    }
    else if(url.indexOf('fieldAuditCard-overview') != -1){
      this.authService.saveValue('fieldAuditCardOverviewdateObj', null);
    }
    else if(url.indexOf('cardScan-detail') != -1){
      this.authService.saveValue('cardScanDetaildateObj', null);
    }
    else if(url.indexOf('bank-sheet') != -1){
      this.authService.saveValue('bankSheetDateObj', null);
    }
    else if(url.indexOf('conductor')!=-1){
      this.authService.saveValue('conductorDateObj',null);
    }
    else if(url.indexOf('overview')!=-1){
      this.authService.saveValue('overviewDateObj',null);
    }
    else if(url.indexOf('bank-rtgs') != -1){
      this.authService.saveValue('bankRTGSSheetDateObj', null);
    }
    else if(url.indexOf('routeWiseDetails') != -1){
      this.authService.saveValue('route', null);
    }
  }

  infoChecker(url){
    if(this.authService.userDetail 
      && !this.authService.userDetail.agencyId
      && (this.authService.userDetail.cities.length > 1 ||  this.authService.userDetail.agencies.length > 1 )
      && url.indexOf(`/${routePaths.multiple}`) == -1){
      this.router.navigate([`/${routePaths.multiple}/`]);
    }
  }

  checkLogin(url: string): boolean {
    if (this.authService.isLoggedIn && this.authService.token) {
      if(mainMenus[url]){
        this.paginationService.paginationService(1, 'Default');
    }
      if (url.indexOf(`/${routePaths.login}`) != -1 || url.indexOf(`/${routePaths.forgetPassword}`) != -1) {
        this.authService.saveValue('isIdle',true)
        this.router.navigate([`/${routePaths.home}/`]);
        return false;
      }
      else if (url.indexOf(`/${routePaths.home}`) != -1) {
        return true;
      } else if (url.indexOf(`/${routePaths.multiple}`) != -1) {
        return true;
      }
    } else {
     
     
      if (url.indexOf(`/${routePaths.login}`) != -1 || url.indexOf(`/${routePaths.forgetPassword}`) != -1) {
        this.authService.saveValue('signoutInitiated', false);
        return true;
      }
      else if (url.indexOf(`/${routePaths.home}`) != -1) {
        // Navigate to the login page with extras
        this.router.navigate([`/${routePaths.login}`]);
        return false;
      }
      else if (url.indexOf(`/${routePaths.transactionBalance}`) != -1) {
        return true;
      }

    }
  }
}
